import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

let state = {
    openID: localStorage.getItem('openID') ? localStorage.getItem('openID') : '',
    idCard: ''
}

let mutations = {
    actionOpenID(state, val) {
        state.openID = val;
        localStorage.setItem("openID", val);
    },
    actionIdCard(state, val) {
        state.idCard = val;
    }
}

export default new Vuex.Store({
    state,
    mutations
});